import { useFormField } from '@calendly/form';
import { FieldError, FieldLabel, useErrorId, useInputId } from '@calendly/form/parts';
import { TextInput } from '@calendly/ui/components/text-input';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "cwl6drl";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const counterNotValidCss = "cw2xh0y";
const counterCss = "c1n3tdcx";
const Counter = forwardRef((props, ref) => {
  const {
    notValid,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(counterCss, {
    [counterNotValidCss]: notValid
  }, props.className)} />;
});
export const TextFieldWithCounter = ({
  label,
  maxLength = 50,
  lengthError,
  required,
  className,
  ...props
}) => {
  const [fieldProps, meta] = useFormField(props);
  const {
    value
  } = fieldProps;
  const isLengthInvalid = value.length > maxLength;
  const error = isLengthInvalid ? lengthError : meta.error;
  const inputId = useInputId({
    id: props.id
  });
  const errorId = useErrorId({
    error
  });
  return <div className={className}>
      <FieldLabel text={label} htmlFor={inputId} isRequired={required} />
      <TextInput {...fieldProps} id={inputId} aria-invalid={Boolean(error)} aria-describedby={errorId} />
      <Container>
        <Counter notValid={isLengthInvalid}>
          {value.length}
          /
          {maxLength}
        </Counter>
        <FieldError text={error} id={errorId} />
      </Container>
    </div>;
};

require("./text-field-with-counter.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./text-field-with-counter.js");